// extracted by mini-css-extract-plugin
module.exports = {"root__button":"ConfirmationDialog_root__button__hXD69","root__headline":"ConfirmationDialog_root__headline__pa7Ko"};